import React, { useState, useContext, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import InfiniteScroll from 'react-infinite-scroller'
import {
  makeStyles,
  TextField,
  InputAdornment,
  LinearProgress,
  FormControl,
  FormControlLabel,
  Switch,
  Button,
  Drawer,
  MenuItem,
  Select,
  Typography,
  Grid,
  Modal,
} from '@material-ui/core'

import { CoreContext } from '../../../../core/context/CoreContext'
import { ProductsContext } from '../../context/ProductsContext'
import { BasketContext } from '../../../../core/context/BasketContext'

import * as DateTransformer from '../../libraries/DateTransformer'

import ProductSearchBarFacets from '../Products//ProductSearchBarFacets'
import EmptyState from '../../components/EmptyState'
import TranslationLabel from '../../../../core/components/TranslationLabel'
import GridView from '../../components/GridView'
import TableView from '../../components/TableView'
import OpenOrdersModal from '../Products/OpenOrdersModal'
import ReservationsModal from '../Products/ReservationModal'

import SearchIcon from '@material-ui/icons/Search'
import MoreIcon from '@material-ui/icons/More'
import GridOnIcon from '@material-ui/icons/GridOn'
import ListIcon from '@material-ui/icons/List'
import CloseIcon from '@material-ui/icons/Close'

import DatePicker from '../../../../shared/DatePicker'

const useStyles = makeStyles((theme) => ({
  productsPageRoot: {
    width: 'calc(100% + 32px)',
    margin: '-8px 20px 0 -16px',
    flexGrow: 1,
    background: 'white',
    display: 'flex',
    flexFlow: 'column',
    height: 'calc(100% - 31px)',
    position: 'relative',

    [theme.breakpoints.up('sm')]: {
      margin: '-17px 20px 0 -16px',
    },
  },
  ProductsPageHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    backgroundColor: '#EAEAEA',
    padding: '10px 15px',

    [theme.breakpoints.down('sm')]: {
      alignItems: 'flex-start',
      flexDirection: 'column-reverse',
    },
  },
  ProductsPageSearch: {
    background: '#fff',
    borderRadius: 4,

    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginBottom: 10,
    },
  },
  textField: {
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  ProductsPageFacets: {
    marginLeft: -10,
  },
  stickyloader: {
    width: '100%',
    visibility: 'hidden',
    position: 'absolute',
  },
  loaderVisible: {
    visibility: 'visible',
  },
  resetButton: {
    display: 'inline-block',
    border: '1px solid lightgrey',
    marginRight: 5,
    marginBottom: 5,
    borderRadius: 2,
    padding: 5,
  },
  resetButtonText: {
    verticalAlign: 'middle',
  },
  greyedOutResetButtonText: {
    color: theme.palette.grey['500'],
  },
  resetButtonIcon: {
    verticalAlign: 'middle',
    marginLeft: 5,
    width: 15,
    height: 15,
  },
  ProductsPageSubHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '10px 15px',
    borderBottom: '1px solid rgba(0, 0, 0, .12)',

    [theme.breakpoints.down('md')]: {
      flexDirection: 'column-reverse',
      alignItems: 'flex-start',
    },
  },
  ProductsPageHeaderResults: {
    display: 'flex',
    alignItems: 'center',
  },
  ProductsPageSettings: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',

    [theme.breakpoints.down('md')]: {
      marginBottom: 10,
      width: '100%',
    },
  },
  ProductsPageSettingsLast: {
    [theme.breakpoints.down('md')]: {
      marginLeft: 'auto',
    },
  },
  ProductsPageHeaderResultsLast: {
    marginLeft: 10,
    paddingLeft: 10,
    borderLeft: '2px solid rgba(0, 0, 0, .12)',
  },
  cursor: {
    cursor: 'pointer',
    textDecoration: 'underline',
  },
  drawer: {
    padding: '20px 10px',
    width: 300,
  },
  moreOptionsRow: {
    width: '100%',
    marginBottom: '20px',
    paddingBottom: '20px',
    borderBottom: '1px solid rgba(0, 0, 0, .12)',
  },
  scrollableProducts: {
    marginTop: 25,
    overflowY: 'scroll',
    flex: '1 1 auto',
  },
  modalWrapper: {
    backgroundColor: 'white',
    width: '500px',
    maxWidth: '100%',
    margin: 'auto',
    position: 'relative',
    top: '50%',
    transform: 'translateY(-50%)',
    padding: '25px',
    paddingTop: 10,
    textAlign: 'center',
    outline: 'none',
  },
  openOrderModalLine: {
    cursor: 'pointer',
    margin: 5,
  },
}))

export default function CampaignPage() {
  const classes = useStyles()
  const location = useParams()

  const core = useContext(CoreContext)
  const productsModel = useContext(ProductsContext)
  const basket = useContext(BasketContext)

  const [openSelectedDate, setOpenSelectedDate] = useState(undefined)
  const [openOrdersModal, setOpenOrdersModal] = useState(undefined)
  const [reservationsModal, setReservationsModal] = useState(undefined)  
  const [showRetailPrice, setShowRetailPrice] = useState(false)
  const [futureCampaign, setFutureCampaign] = useState(false)
  const [campaign, setCampaign] = useState({})
  const [_, setRequestedShippingDate] = useState(new Date())
  const [drawerState, setDrawerState] = useState({
    moreOptions: false,
    filters: false,
  })

  const isBuyButtonDisabled = (shippingFromDate, shippingToDate) => {
    const now = currentDateValue().setHours(12, 0, 0, 0)
    return now >= new Date(shippingFromDate) && now <= new Date(shippingToDate)
  }

  useEffect(() => {
    if (core.user.selectedCustomer.accountNo && location.hasOwnProperty('id')) {
      productsModel.init(null)

      core.dataStore
        .GetCampaignsByCustomerNo(core.user.selectedCustomer.accountNo)
        .then((res) => {
          const campaign = res.data.find((x) => x.campaignId == location.id)
          if (!campaign) {
            return
          }
          setFutureCampaign(
            !isBuyButtonDisabled(
              campaign.shippingFromDate,
              campaign.shippingToDate,
            ),
          )
          setCampaign(campaign)
        })
    }
  }, [core.user.selectedCustomer.accountNo])

  useEffect(() => {
    if (productsModel.getSelecteFacetValuesCount() == 0) {
      setDrawerState({ ...drawerState, ['filters']: false })
    }
  }, [productsModel.selectedFacetValues])

  const getFacetLabelByCategoryAndId = (category, id) => {
    if (
      !productsModel.allFacets ||
      !productsModel.allFacets.find((el) => el.name === category)
    ) {
      return
    }

    let facetLabel = ''
    let count =
      productsModel.searchCollection.facets
        .find((el) => el.name === category)
        .facetValues.find((el) => el.id === id)?.count ?? 0

    if (category === 'news') {
      facetLabel = (
        <span>
          <TranslationLabel name='news' /> ({count})
        </span>
      )
    } else if (category === 'archive') {
      facetLabel = (
        <span>
          <TranslationLabel name='archive' /> ({count})
        </span>
      )
    } else {
      const label = productsModel.allFacets
        .find((el) => el.name === category)
        .facetValues.find((el) => el.id === id)
      facetLabel = label && `${label.name} (${count})`
    }

    return (
      <>
        <span
          className={
            count ? classes.resetButtonText : classes.greyedOutResetButtonText
          }>
          {facetLabel}
        </span>
        <CloseIcon className={classes.resetButtonIcon} />
      </>
    )
  }

  const getArrayOfFacets = (selectedFacetValues) => {
    let facets = []
    for (const category in selectedFacetValues) {
      selectedFacetValues[category].forEach((el) => {
        facets.push({ category, value: el })
      })
    }
    return facets
  }

  const addToBasket = (product) => {
    if (basket.basket.requestedShippingDate == null) {
      setOpenSelectedDate(product)
      return
    }

    basket.add({
      itemId: product.productNo,
      qty: product.quantity,
      campaignId: product.priceDtos[0].campaignId,
      requestedShippingDate: basket.basket.requestedShippingDate,
    })
  }

  const setDate = (x) => {
    const date = new Date(x.setHours(12, 0, 0, 0))
    basket.basket.requestedShippingDate = `${date.getFullYear()}-${String(
      date.getMonth() + 1,
    ).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}T00:00:00`
    setRequestedShippingDate(x)
  }

  const currentDateValue = () => {
    if (basket.basket.requestedShippingDate) {
      return new Date(basket.basket.requestedShippingDate)
    }

    const date = new Date()
    return new Date(date.setDate(date.getDate() + 1))
  }

  const handleLoadMore = () => {
  const date = currentDateValue()
  productsModel.increment(date)
  }

  const getMinDate = () => {
    const date = new Date()
    return new Date(date.setDate(date.getDate() + 1))
  }

  return (
    <div className={classes.productsPageRoot}>
      <Modal
        open={!!openSelectedDate}
        onClose={() => setOpenSelectedDate(undefined)}>
        <div className={classes.modalWrapper}>
          <Typography
            style={{ marginBottom: 25, marginTop: 15 }}
            variant='h5'>
            <TranslationLabel name='campaignNoShippingDateChoosen' />
          </Typography>

          <div>
            <DatePicker
              autoOk
              size='small'
              disablePast
              variant='inline'
              inputVariant='outlined'
              label={<TranslationLabel name='chooseShippingDate' />}
              minDate={getMinDate()}
              maxDate={campaign.shippingToDate}
              onChange={(e) => setDate(e)}
              className={classes.datePicker}
              disabled={basket.basket.entries.find((x) => x.campaignId != null)}
              value={currentDateValue()}
            />
          </div>

          <Button
            style={{ marginTop: 20 }}
            variant='outlined'
            color='primary'
            onClick={() => {
              const date = currentDateValue()

              basket.add({
                itemId: openSelectedDate.productNo,
                qty: openSelectedDate.quantity,
                campaignId: openSelectedDate.priceDtos[0].campaignId,
                requestedShippingDate: `${date.getFullYear()}-${String(
                  date.getMonth() + 1,
                ).padStart(2, '0')}-${String(date.getDate()).padStart(
                  2,
                  '0',
                )}T00:00:00`,
              })

              setOpenSelectedDate(undefined)
            }}>
            <TranslationLabel name='ok' />
          </Button>
        </div>
      </Modal>
      <OpenOrdersModal
        openOrdersProduct={productsModel.searchCollection?.products?.find(
          (el) => el && el.productNo == openOrdersModal,
        )}
        setOpenOrdersModal={setOpenOrdersModal}
      />
      <ReservationsModal
        reservationsProduct={productsModel.searchCollection?.products?.find(
          (el) => el && el.productNo == reservationsModal,
        )}
        setReservationsModal={setReservationsModal}
      />

      <div className={classes.ProductsPageHeader}>
        <div className={classes.ProductsPageFacets}>
          <ProductSearchBarFacets
            facets={productsModel.searchCollection.facets}
            query={productsModel.searchCollection.query}
            selected={productsModel.selectedFacetValues}
            change={productsModel.toggleFacetValue}
          />
        </div>

        <div className={classes.ProductsPageSearch}>
          <TextField
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                productsModel.handleSearchQueryChange(productsModel.query)
              }
            }}
            placeholder={core.dictionary.getLabel('searchProducts')}
            type='search'
            className={classes.textField}
            variant='outlined'
            onChange={(e) => productsModel.setQuery(e.target.value)}
            value={productsModel.query}
            size='small'
            InputProps={{
              startAdornment: (
                <InputAdornment position='start'>
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </div>
      </div>

      <div className={classes.ProductsPageSubHeader}>
        <div className={classes.ProductsPageHeaderResults}>
          <div>
            <Typography>
              <TranslationLabel name='displaying' />{' '}
              {productsModel.searchCollection.totalNumberOfResults ?? 0}{' '}
              <TranslationLabel name='results' />
              <span> &nbsp; &nbsp; </span>
              <TranslationLabel name='fromCampaign' /> {campaign.campaignName}
              <span> &nbsp; &nbsp; </span>
              <TranslationLabel name='campaignShippingPeriod' />{' '}
              {DateTransformer.formatDate(campaign.shippingFromDate)} -{' '}
              {DateTransformer.formatDate(campaign.shippingToDate)}
              {basket.basket.requestedShippingDate && (
                <>
                  <span> &nbsp; &nbsp; </span>
                  <TranslationLabel name='campaignRequestedShippingDate' />{' '}
                  {DateTransformer.formatDate(
                    new Date(basket.basket.requestedShippingDate),
                  )}
                </>
              )}
            </Typography>
          </div>

          {productsModel.getSelecteFacetValuesCount() > 0 && (
            <div className={classes.ProductsPageHeaderResultsLast}>
              <Typography
                className={classes.cursor}
                onClick={() =>
                  setDrawerState({ ...drawerState, ['filters']: true })
                }>
                <TranslationLabel name='editAndRemoveFilters' /> (
                {productsModel.getSelecteFacetValuesCount()})
              </Typography>
              <Drawer
                anchor='right'
                open={drawerState['filters']}
                onClose={() =>
                  setDrawerState({ ...drawerState, ['filters']: false })
                }>
                <div className={classes.drawer}>
                  <Button
                    size='small'
                    onClick={() => productsModel.reset()}
                    className={classes.resetButton}>
                    <span className={classes.resetButtonText}>
                      <TranslationLabel name='resetFilters' />
                      <CloseIcon className={classes.resetButtonIcon} />
                    </span>
                  </Button>

                  {getArrayOfFacets(productsModel.selectedFacetValues).map(
                    (el) => (
                      <Button
                        size='small'
                        key={el.value + el.category}
                        onClick={() =>
                          productsModel.toggleFacetValue(el.category, el.value)
                        }
                        className={classes.resetButton}>
                        {getFacetLabelByCategoryAndId(el.category, el.value)}
                      </Button>
                    ),
                  )}

                  {productsModel.query != '' && (
                    <Button
                      size='small'
                      onClick={() => {
                        productsModel.setQuery('')
                        productsModel.handleSearchQueryChange('')
                      }}
                      className={classes.resetButton}>
                      <>
                        <span className={classes.resetButtonText}>
                          {productsModel.query}
                        </span>
                        <CloseIcon className={classes.resetButtonIcon} />
                      </>
                    </Button>
                  )}
                </div>
              </Drawer>
            </div>
          )}
        </div>

        <div className={classes.ProductsPageSettings}>
          <FormControl>
            <FormControlLabel
              label={<TranslationLabel name='showRetailPrice' />}
              control={
                <Switch
                  checked={showRetailPrice}
                  onChange={() => setShowRetailPrice(!showRetailPrice)}
                  color='primary'
                />
              }
            />
          </FormControl>

          <MoreIcon
            className={`${classes.cursor} ${classes.ProductsPageSettingsLast}`}
            onClick={() =>
              setDrawerState({ ...drawerState, ['moreOptions']: true })
            }
          />
          <Drawer
            anchor='right'
            open={drawerState['moreOptions']}
            onClose={() =>
              setDrawerState({ ...drawerState, ['moreOptions']: false })
            }>
            <div className={classes.drawer}>
              <div className={classes.moreOptionsRow}>
                <Typography>
                  <TranslationLabel name='sortBy' />
                </Typography>
                <FormControl
                  variant='outlined'
                  className={classes.formControl}
                  size='small'
                  style={{ width: '100%' }}>
                  <Select
                    value={productsModel.searchCollection.sortField || 'BRAND'}
                    onChange={(event) =>
                      productsModel.handleSortByChange(event.target.value)
                    }
                    className={classes.selectEmpty}>
                    <MenuItem value='Name'>
                      <TranslationLabel name='title'></TranslationLabel>
                    </MenuItem>
                    <MenuItem value='Id'>
                      <TranslationLabel name='itemNo'></TranslationLabel>
                    </MenuItem>
                    <MenuItem value='BrandId'>
                      <TranslationLabel name='brand'></TranslationLabel>
                    </MenuItem>
                  </Select>
                </FormControl>
              </div>

              <div className={classes.moreOptionsRow}>
                <Typography>Vælg visning form</Typography>
                <FormControl
                  variant='outlined'
                  className={classes.formControl}
                  size='small'
                  style={{ width: '100%' }}>
                  <Select
                    value={productsModel.listViewMode}
                    onChange={(event) =>
                      productsModel.setListViewMode(event.target.value)
                    }
                    className={classes.selectEmpty}>
                    <MenuItem value='list'>
                      <span style={{ display: 'flex', alignItems: 'center' }}>
                        <ListIcon style={{ paddingRight: 10 }} /> List
                      </span>
                    </MenuItem>
                    <MenuItem value='grid'>
                      <span style={{ display: 'flex', alignItems: 'center' }}>
                        <GridOnIcon style={{ paddingRight: 10 }} /> Grid
                      </span>
                    </MenuItem>
                  </Select>
                </FormControl>
              </div>
            </div>
          </Drawer>
        </div>
      </div>

      <LinearProgress
        className={`${classes.stickyloader} ${
          productsModel.isLoading && classes.loaderVisible
        }`}
      />

      {productsModel.searchCollection.products && (
        <div className={classes.scrollableProducts}>
          <InfiniteScroll
            loadMore={handleLoadMore}
            hasMore={productsModel.hasMore}
            threshold={100}
            initialLoad={false}
            useWindow={false}
            id={'product-scroller'}>
            {productsModel.listViewMode === 'list' ? (
              <TableView
                products={productsModel.searchCollection.products}
                showRetailPrice={showRetailPrice}
                listKey={'productNo'}
                disabledBuyButton={futureCampaign}
                setOpenOrdersModal={setOpenOrdersModal}
                setReservationsModal={setReservationsModal}
                addToBasket={addToBasket}
              />
            ) : (
              <Grid
                container
                spacing={2}
                style={{ padding: '0 10px', margin: 0, width: '100%' }}>
                <GridView
                  products={productsModel.searchCollection.products}
                  showRetailPrice={showRetailPrice}
                  listKey={'productNo'}
                  disabledBuyButton={futureCampaign}
                  setOpenOrdersModal={setOpenOrdersModal}
                  setReservationsModal={setReservationsModal}
                  addToBasket={addToBasket}
                />
              </Grid>
            )}
          </InfiniteScroll>
        </div>
      )}

      {!productsModel.isLoading &&
        productsModel.searchCollection.totalNumberOfResults === 0 && (
          <EmptyState
            main='CampaignEmptyMain'
            sub='CampaignEmptyMain'
          />
        )}
    </div>
  )
}
